<template>
    <div id="app" v-if="ajaxLoaded">
        <goldHead :goldData="userData.goldData"></goldHead>
        <lendMoney :bankData=userData.bankData></lendMoney>
    </div>
    <div class="error" v-else-if="ajaxError">
        <goldHead :goldData="userData.goldData"></goldHead>
    </div>
</template>

<script type="text/javascript">
    import goldHead from './components/Gold-head.vue';
    import lendMoney from './components/LendMoney.vue';
    import jm from "./tools/jm"

    export default {
        data: () => ({
            ajaxLoaded: false,
            ajaxError: false,
            userData: {},
        }),
        beforeCreate: function () {
            var self = this;
            var sid = jm.getCookie("sid") || jm.getUrlString("sid");
            $.ajax({
                url: "//ms.jr.jd.com/gw/generic/base/h5/m/getBorrowMoneyMess",
                data: {sid: sid},
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    var data = data.resultData;
                    if (data) {
                        self.ajaxLoaded = true;
                        self.userData = {
                            goldData: {
                                ajaxError: false,
                                isOpenJt: data.isOpenJt,
                                isLogin: data.isLogin,
                                availableAssets: data.availableAssets
                            },
                            bankData: {
                                isLogin: data.isLogin,
                                lendmoneyList: data.lendmoneyList
                            }
                        };
                    } else {
                        self.ajaxLoaded = false;
                        self.ajaxError = true;
                        self.userData = {
                            goldData: {
                                ajaxError: true,
                                isOpenJt: false,
                                isLogin: false
                            }
                        };
                    }
                }
            })
        },
        components: {goldHead, lendMoney}
    }
</script>

<style>
    @import './assets/css/base.css'

</style>




// WEBPACK FOOTER //
// App.vue?d2689376